// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as UnitInfoRect from "./UnitInfoRect.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";

function UnitsGrid$Group(Props) {
  var units = Props.units;
  var stats = Props.stats;
  var totalEntries = Props.totalEntries;
  var cost = Props.cost;
  var onUnitSelected = Props.onUnitSelected;
  return React.createElement("div", {
              className: CssJs.style([
                    CssJs.background(Colors.tierDesaturatedColorAlpha2(cost, 0.17)),
                    CssJs.padding2(CssJs.px(14), CssJs.px(12))
                  ])
            }, React.createElement("div", {
                  className: CssJs.style([
                        CssJs.display(CssJs.grid),
                        CssJs.gridTemplateColumns([{
                                NAME: "repeat",
                                VAL: [
                                  "autoFill",
                                  {
                                    NAME: "minmax",
                                    VAL: [
                                      CssJs.px(140),
                                      CssJs.fr(1)
                                    ]
                                  }
                                ]
                              }]),
                        CssJs.gridGap(CssJs.px(12)),
                        T.lg_([
                              CssJs.gridTemplateColumns([{
                                      NAME: "repeat",
                                      VAL: [
                                        "autoFill",
                                        {
                                          NAME: "minmax",
                                          VAL: [
                                            CssJs.px(140),
                                            CssJs.fr(1)
                                          ]
                                        }
                                      ]
                                    }]),
                              CssJs.gridRowGap(CssJs.px(16))
                            ])
                      ])
                }, Belt_Array.map(units, (function (unitId) {
                        var stats$1 = Js_dict.get(stats, unitId);
                        if (stats$1 !== undefined) {
                          return React.createElement(UnitInfoRect.make, {
                                      stats: stats$1,
                                      totalEntries: totalEntries,
                                      unitId: unitId,
                                      onUnitSelected: onUnitSelected,
                                      key: unitId
                                    });
                        } else {
                          return null;
                        }
                      }))));
}

var Group = {
  make: UnitsGrid$Group
};

function UnitsGrid(Props) {
  var totalEntries = Props.totalEntries;
  var stats = Props.stats;
  var onUnitSelected = Props.onUnitSelected;
  var set = TftSet.use(undefined);
  ApertureCtx.useValue(undefined);
  var g1 = Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
          return Sd.unitTier(unitId) === 1;
        }));
  var g2 = Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
          return Sd.unitTier(unitId) === 2;
        }));
  var g3 = Belt_Array.keep(Sd.allUnits4(set), (function (unitId) {
          return Sd.unitTier(unitId) === 3;
        }));
  var g4 = Belt_SortArray.stableSortBy(Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
              return Sd.unitTier(unitId) === 4;
            })), Caml.caml_string_compare);
  var g5 = Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
          return Sd.unitTier(unitId) === 5;
        }));
  var g6 = Belt_Array.keep(Sd.allUnits2(set), (function (unitId) {
          return Sd.unitTier(unitId) === 6;
        }));
  return React.createElement("div", {
              className: "flex flex-col w-full"
            }, React.createElement("div", {
                  className: "flex flex-col gap-6"
                }, React.createElement(UnitsGrid$Group, {
                      units: g1,
                      stats: stats,
                      totalEntries: totalEntries,
                      cost: 1,
                      onUnitSelected: onUnitSelected
                    }), React.createElement(UnitsGrid$Group, {
                      units: g2,
                      stats: stats,
                      totalEntries: totalEntries,
                      cost: 2,
                      onUnitSelected: onUnitSelected
                    }), React.createElement(UnitsGrid$Group, {
                      units: g3,
                      stats: stats,
                      totalEntries: totalEntries,
                      cost: 3,
                      onUnitSelected: onUnitSelected
                    }), React.createElement(UnitsGrid$Group, {
                      units: g4,
                      stats: stats,
                      totalEntries: totalEntries,
                      cost: 4,
                      onUnitSelected: onUnitSelected
                    }), React.createElement(UnitsGrid$Group, {
                      units: g5,
                      stats: stats,
                      totalEntries: totalEntries,
                      cost: 5,
                      onUnitSelected: onUnitSelected
                    }), set === 130 ? React.createElement(UnitsGrid$Group, {
                        units: g6,
                        stats: stats,
                        totalEntries: totalEntries,
                        cost: 5,
                        onUnitSelected: onUnitSelected
                      }) : null));
}

var make = UnitsGrid;

export {
  Group ,
  make ,
  
}
/* T Not a pure module */
